export default {
  methods: {
    idopColor (index) {
      let result
      const val = index.toString()
      switch (val) {
        case '0':
          result = { 'red-text': true }
          break;
        case '1':
          result = { 'green-text': true }
          break;
      }
      return result
    }
  }
}